class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    const parent = this.notification.parentElement;
    parent.classList.add('active');
    setTimeout(function () {
      parent.classList.add('open');
    }, 250);

  }

  close() {
    const parent = this.notification.parentElement;
    parent.classList.remove('open');
    setTimeout(function () {
      parent.classList.add('active');
    }, 250);
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.warn('No sections in parsedState, reloading page');
      window.location.reload();
      return;
    }

    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach(section => {
      var _sectionId = document.getElementById(section.id);
      if (!_sectionId) {
        console.warn(`Section element not found: ${section.id}, reloading page`);
        window.location.reload();
        return;
      }

      if (!parsedState.sections[section.id]) {
        console.warn(`Section HTML not found for: ${section.id}, reloading page`);
        window.location.reload();
        return;
      }

      try {
        const sectionHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        if (sectionHTML) {
          _sectionId.innerHTML = sectionHTML;
        }
        if (section.id === 'cart-notification-product') {
          var _items = _sectionId.querySelectorAll('.cart-item');
          if (!_items.length) {
            _sectionId.classList.add('_empty');
          } else {
            _sectionId.classList.remove('_empty');
          }
        }
      } catch (e) {
        console.error(`Error rendering section ${section.id}:`, e);
        window.location.reload();
      }
    });

    if (this.header) this.header.reveal();
    
    // Show success message briefly without opening the full cart
    // This gives user feedback that item was added successfully
    this.showSuccessMessage();
  }

  showSuccessMessage() {
    // Show a simple success message near the cart icon, not the full popup
    const cartIconHeader = document.querySelector('#cart-icon-header') || 
                           document.querySelector('#cart-icon-bubble') ||
                           document.querySelector('[id*="cart-icon"]');
    
    if (!cartIconHeader) {
      console.log('[CART NOTIFICATION] Cart icon not found for success message');
      return;
    }

    // Create a simple toast notification
    const notification = document.createElement('div');
    notification.className = 'cart-success-message';
    notification.textContent = 'Item added to cart!';
    notification.style.cssText = `
      position: absolute;
      top: -10px;
      right: 40px;
      background: #4caf50;
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      z-index: 1000;
      font-size: 14px;
      white-space: nowrap;
      animation: slideInDown 0.3s ease-out;
    `;

    // Add animation if not already in styles
    if (!document.getElementById('cart-success-message-styles')) {
      const style = document.createElement('style');
      style.id = 'cart-success-message-styles';
      style.textContent = `
        @keyframes slideInDown {
          from { transform: translateY(-10px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }

    // Make sure cart icon has relative positioning
    const originalPosition = window.getComputedStyle(cartIconHeader).position;
    if (originalPosition === 'static') {
      cartIconHeader.style.position = 'relative';
    }

    cartIconHeader.appendChild(notification);

    // Remove after 2 seconds
    setTimeout(() => {
      notification.style.animation = 'slideInDown 0.3s ease-out reverse';
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 2000);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-icon-header'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    try {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const element = parsed.querySelector(selector);
      return element ? element.innerHTML : '';
    } catch (e) {
      console.error('Error parsing section HTML:', e);
      return '';
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateQuantity(line, quantity, sections) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.renderContents(parsedState);
      }).catch(() => {
      })
      .finally(() => {
        // for animation if .... necesary
      });
  }
}


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

customElements.define('cart-notification', CartNotification);

class ItemRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var line = this.dataset.index;
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var sections = cartNotification.getSectionsToRender().map((section) => section.id);
      cartNotification.updateQuantity(line, 0, sections);
    });
  }
}

customElements.define('item-remove-button', ItemRemoveButton);
